/// <reference types="google.maps" />

import { AfterViewInit, Component, Inject, OnDestroy, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GoogleMap } from '@angular/google-maps';
// import { LatLngLiteral, MapTypeStyle } from '@agm/core';
// import { DrawingControlOptions, OverlayType } from '@agm/drawing';

import { SessionService } from 'src/app/shared/services';
// import { PolygonPathEvent } from '@agm/core/directives/polygon';
import { makeLabelOverlay } from 'src/app/shared/components/maps/shared/label-overlay';
import { GoogleMapsLoaderService } from '../shared/google-maps-loader.service';
import { DOCUMENT } from '@angular/common';

export interface Areas {
  coords: google.maps.LatLngLiteral[];
  label?: string;
  options: google.maps.PolygonOptions;
}

export interface MapsPolygonConfig {
  title?: string;
  modalClass?: string;
  okText?: string;
  cancelText?: string;
  position: {
    lat: number;
    lng: number;
  }
  zoom: number;
  area?: google.maps.LatLngLiteral[];
  readOnlyAreas?: Areas[];
  restriction?: google.maps.MapRestriction;
  editing?: boolean;
}

export interface MapsPolygonResult {
  area: google.maps.LatLngLiteral[];
  m2: number;
}


@Component({
  selector: 'app-maps-polygon',
  templateUrl: './maps-polygon.component.html',
  styleUrls: ['./maps-polygon.component.scss'],
  providers: [GoogleMapsLoaderService]
})
export class MapsPolygonComponent implements OnDestroy, AfterViewInit {
  private resolve: any;
  private reject: any;

  public apiLoaded: boolean = false;
  public initCoords: google.maps.LatLngLiteral[] = [];
  public coords: google.maps.LatLngLiteral[] = [];
  public areaSelecionada: number = 0;
  public areaHa: number = 0;

  @ViewChild('map') map: GoogleMap;
  drawingManager: google.maps.drawing.DrawingManager;

  public options: google.maps.MapOptions = {
    center: {
      lat: -18.9938929,
      lng: -40.3970775
    },
    mapTypeId: 'hybrid',  // google.maps.MapTypeId.HYBRID,
    styles: [
      {
        elementType: 'all',
        featureType: 'landscape',
        stylers: []
      }
    ],
    zoom: 11
  };

  public polygonOptions: google.maps.PolygonOptions = {
    editable: true,
    draggable: true,
    geodesic: true,
    paths: [],
    strokeColor: '#00FFFF', // '#F5F1BC',
    fillColor: '#7FB7F6',
    strokeWeight: 1.5
  };

  public config: MapsPolygonConfig = null;

  constructor(
    private bsModalRef: BsModalRef,
    private sessionService: SessionService,
    public googleMapsLoaderService: GoogleMapsLoaderService,
    @Inject(DOCUMENT) private document: any
  ) { }

  ngOnDestroy() {
    this.removeGoogleMapScript();
  }

  ngAfterViewInit() {
    this.googleMapsLoaderService.apiLoaded.subscribe((ok) => {
      this.apiLoaded = true;
      setTimeout(function () {
        this.drawPolygon();
      }.bind(this), 500);
    })
  }

  private setMapOptions(): void {
    if (!this.config.position) {
      this.config.position = {lat: null, lng: null};
    }

    if (!this.config.position.lat) {
      this.config.position.lat = -18.9117057;
      this.config.position.lng = -40.3496894;
      this.config.zoom = 10;
    }

    this.options.center.lat = this.config.position.lat;
    this.options.center.lng = this.config.position.lng;
    this.options.zoom = this.config.zoom;

    this.polygonOptions.editable = this.config.editing;

    if (!this.config.position.lat) {
      this.sessionService.userData().subscribe(data => {
        this.config.position.lat = data.unit.latitude;
        this.config.position.lng = data.unit.longitude;
      });
    }
  }

  private clearDrawing(): void {
    this.polygonOptions.draggable = false;
    this.polygonOptions.visible = false;
    this.polygonOptions.editable = false;

    this.drawingManager.setOptions({});
  }

  private calcArea(): void {
    const latLng = this.coords.map(c => (new google.maps.LatLng(c.lat, c.lng)));
    this.areaSelecionada = google.maps.geometry.spherical.computeArea(latLng);
    this.areaHa = this.areaSelecionada > 0 ? this.areaSelecionada / 10000 : 0;
  }

  public setOption(resolve: any, reject: any, config: MapsPolygonConfig) {
    this.resolve = resolve;
    this.reject = reject;
    this.config = config;

    this.setMapOptions();
    // console.log(this.config);

    if (this.config.area) {
      this.initCoords = this.config.area;
      this.coords = this.initCoords;
      setTimeout(function () {
        this.calcArea();
      }.bind(this), 3000);
    }
  }

  public ok(event: Event) {
    this.resolve({ area: this.coords, m2: this.areaSelecionada });
    this.bsModalRef.hide();
  }

  public cancel(event: Event) {
    this.reject(false);
    this.bsModalRef.hide();
  }

  public setActualArea(event: Event): void {
    if (this.config.readOnlyAreas) {
      if (this.config.readOnlyAreas.length === 1) {
        this.coords = this.config.readOnlyAreas[0].coords;
        this.initCoords = this.coords;
        this.config.editing = true;
        this.calcArea();
        this.clearDrawing();
      }
    }
  }

  drawPolygon() {
    this.drawingManager = new google.maps.drawing.DrawingManager({
      drawingMode: google.maps.drawing.OverlayType.POLYGON,
      drawingControl: true,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
        drawingModes: [google.maps.drawing.OverlayType.POLYGON],
      },
      polygonOptions: this.polygonOptions
    });

    this.drawingManager.setMap(this.map.googleMap);
    google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (event) => {
      // Polygon drawn
      if (event.type === google.maps.drawing.OverlayType.POLYGON) {
        //this is the coordinate, you can assign it to a variable or pass into another function.
        this.coords = event.overlay.getPath().getArray().map((coord: google.maps.LatLng) => coord.toJSON());
        this.calcArea();
      }
    });
  }

  removeGoogleMapScript() {
    // todo: temp workaround for 'You have included the Google Maps API multiple times on this page'
    const keywords = ['maps.googleapis'];

    // Remove google from BOM (window object)
    // @ts-ignore
    window.google = undefined;

    // Remove google map scripts from DOM
    const scripts = this.document.head.getElementsByTagName('script');
    for (let i = scripts.length - 1; i >= 0; i--) {
      const scriptSource = scripts[i].getAttribute('src');
      if (scriptSource != null) {
        if (keywords.filter(item => scriptSource.includes(item)).length) {
          scripts[i].remove();
          // scripts[i].parentNode.removeChild(scripts[i]);
        }
      }
    }
  }

}
